export default __webpack_public_path__ + "static/media/Kanipakam-slider-04@2x.b3ebe4e8.png";